import { Modal } from "../../../Modal";
import { Dispatch, SetStateAction, useContext, useRef, useState } from "react";
import { ButtonStyled } from "../../../Button/styles";
import { ModalTermStyled, TermStyled } from "./stylesTerm";
import { UserContext } from "../../../../providers/UserContext";
import { ModalTerm } from "../../../ModalTerm";

type iModalConfirmTerm = {
	showConfirmTerm: boolean;
	setShowConfirmTerm: Dispatch<SetStateAction<boolean>>;
};

export const ModalConfirmTerm = ({
	showConfirmTerm,
	setShowConfirmTerm,
}: iModalConfirmTerm) => {
	const [showModalTerm, SetShowModalTerm] = useState(false);

	const checkboxRef = useRef<HTMLInputElement>(null);

	const { updateUserTerm } = useContext(UserContext);

	const handleButtonClick = () => {
		console.log(checkboxRef.current?.checked);
		if (!checkboxRef.current?.checked) {
			console.log("Você precisa aceitar o termo de uso para continuar!!");
		} else {
			setShowConfirmTerm(false)
			updateUserTerm(checkboxRef.current.checked);
		}
	};

	return (
		<>
			{/* Se for falso mostra o modal */}
			{!showConfirmTerm && (
				<Modal closeButton={true} showModal={setShowConfirmTerm}>
					<div className="card">
						<h1>Aceitar termo</h1>
						<TermStyled>
							<ModalTermStyled>
								<div>
									<input
										type="checkbox"
										ref={checkboxRef}
										id="confirm"
										placeholder="confirm"
										autoComplete="on"
										alt="confirm"
									/>
									<label htmlFor="confirm">
										Eu aceito os{" "}
										<button className="term-condition"
											type="button"
											onClick={() => {
												SetShowModalTerm(true);
											}}
										>
											Termos e Condições de Uso
										</button>
									</label>
								</div>
								<ButtonStyled onClick={handleButtonClick}>Confirmar</ButtonStyled>
							</ModalTermStyled>
						</TermStyled>
					</div>
				</Modal>
			)}
			<ModalTerm
				showModalTerm={showModalTerm}
				setShowModalTerm={SetShowModalTerm}
			/>
		</>
	);
};
